import React, { useEffect } from 'react';
import AdminLeftNavBar from '../admin/leftNavBar/AdminLeftNavBar';
import { useLocation, useNavigate } from 'react-router-dom';
import AdminMembers from '../admin/AdminMembers';
import AdminSupports from '../admin/AdminSupports';
import { useAuth } from '../shared/hooks/useApi/useAuth';
import AdminSystemAlert from '../admin/AdminSystemAlert';
import { ModalType } from '../shared/enum/EnumRepository';
import { useModalStore } from '../shared/store/portal/modalStore';
import AdminMaterialAliases from '../admin/AdminMaterialAliases';
import AdminVenues from '../admin/AdminVenues';


const Admin: React.FC = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const { setStandardModal } = useModalStore();
  // 로그인 안했거나 ADMIN 아니면 일단 나가
  useEffect(() => {
    if(!user) {
      setStandardModal({
        modalType: ModalType.LOGIN,
        title: null,
        value: null,
        handleChange: () => {},
        option: true
      });
    }
    if (user && user.role !== "ADMIN") {
      navigate("/");
    }
  }, [user]);

  if(!user || user.role !== "ADMIN") {
    return null;
  }

  const renderAdminPage = () => {
    switch (pathname) {
      case '/admin/members':
        return <AdminMembers />;
      case '/admin/venues':
        return <AdminVenues />;
      case '/admin/supports':
        return <AdminSupports />;
      case '/admin/system-alert':
        return <AdminSystemAlert />;
      case '/admin/material-aliases':
        return <AdminMaterialAliases />;
      default:
        return <AdminMembers />;
    }
  }

  return (
    <>
      <AdminLeftNavBar />
      {renderAdminPage()}
    </>
  );
}

export default Admin;
